import { type HighlightIconVariant, type IconName } from '@dev-spendesk/grapes';

import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';

export type Dimension = 'costCenter' | 'expenseCategory' | 'supplier';
// | 'customField' // TODO: support custom fields later

export const DIMENSIONS: Dimension[] = [
  'costCenter',
  'expenseCategory',
  'supplier',
  // 'customField', // TODO: support custom fields later
];

export const BASIC_DIMENSIONS: Dimension[] = ['costCenter', 'expenseCategory'];

export const getDimensions = (hasAdvancedDimensions: boolean) =>
  hasAdvancedDimensions ? DIMENSIONS : BASIC_DIMENSIONS;

export const getDimensionOptions = (
  hasAdvancedDimensions: boolean,
  t: TGlobalFunctionTyped,
) =>
  getDimensions(hasAdvancedDimensions).map((dimension) => ({
    key: dimension,
    label: getDimensionTranslation(dimension, t),
  }));

export const getDimensionTranslation = (
  dimension: Dimension,
  t: TGlobalFunctionTyped,
) => {
  switch (dimension) {
    case 'costCenter':
      return t('budgetByDimensions.dimensions.costCenter.title');
    case 'expenseCategory':
      return t('budgetByDimensions.dimensions.expenseCategory.title');
    case 'supplier':
      return t('budgetByDimensions.dimensions.supplier.title');
    // case 'customField':
    //   return t('budgetByDimensions.dimensions.customField.title');
    default:
      return dimension;
  }
};

export const getDimensionIcon = (
  dimension: Dimension,
): { name: IconName; variant: HighlightIconVariant } => {
  switch (dimension) {
    case 'costCenter':
      return { name: 'building-bank', variant: 'peach' };
    case 'expenseCategory':
      return { name: 'banknote', variant: 'ocean' };
    case 'supplier':
      return { name: 'building-storefront', variant: 'lemon' };
    default:
      return { name: 'building-bank', variant: 'purple' };
  }
};
